import * as actions from "./actionsTypes";

const initialData = {
  loadingList: false,
  saveLoading: false,
  capacitacionListLength: 0,
  capacitacionList: [],
  loading: false,
  capacitacion: {},
  loadingBloque: false,
  bloque: {},
  bloques: [],
  tareas: [],
  bandera: false,
  loadingEstadoActividad: false,
  loadingBloqueActual: false,
  bloque_actual: {},
  loadingBloqueAnteriorAnterior: false,
  bloque_anterior_anterior: {},
  bloque_anterior: {},
  bloque_siguiente: {},
  errorCorreoOnboarding: "",
};

export default function CapacitacionOnBoardingReducer(
  state = initialData,
  action
) {
  switch (action.type) {
    case actions.LOADING_CAPACITACION_LISTADO:
      return { ...state, loadingList: action.payload };
    case actions.SAVE_LOADING_CAPACITACION:
      return { ...state, saveLoading: action.payload };
    case actions.GET_CAPACITACION_LISTADO:
      return {
        ...state,
        capacitacionList: action.payload.capacitacionList,
        capacitacionListLength: action.payload.capacitacionListLength,
      };
    case actions.LOADING_CAPACITACION:
      return { ...state, loading: action.payload };
    case actions.GET_CAPACITACION:
      return {
        ...state,
        capacitacion: action.payload.capacitacion,
        bloques: action.payload.bloques,
      };
    case actions.LOADING_BLOQUE:
      return { ...state, loadingBloque: action.payload };
    case actions.GET_BLOQUE:
      return {
        ...state,
        bloque: action.payload.bloque,
        tareas: action.payload.tareas,
        bandera: action.payload.bandera,
      };
    case actions.LOADING_BLOQUE_ACTUAL:
      return { ...state, loadingBloqueActual: action.payload };
    case actions.GET_BLOQUE_ACTUAL:
      return {
        ...state,
        bloque_actual: action.payload.bloque_actual,
        bloque_anterior: action.payload.bloque_anterior,
        bloque_siguiente: action.payload.bloque_siguiente,
      };
    case actions.LOADING_BLOQUE_ANTERIOR_ANTERIOR:
      return { ...state, loadingBloqueAnteriorAnterior: action.payload };
    case actions.GET_BLOQUE_ANTERIOR_ANTERIOR:
      return {
        ...state,
        bloque_anterior_anterior: action.payload.bloque_anterior_anterior,
      };
    case actions.LOADING_ESTADO_ACTIVIDAD:
      return { ...state, loadingEstadoActividad: action.payload };
    case actions.CORREO_FAIL:
      return { ...state, errorCorreoOnboarding: action.payload };
    default:
      return state;
  }
}
